module.exports = __webpack_public_path__ + "static/img/naturalCircle1h.964cb70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle1h.svg
// module id = MTxG
// module chunks = 1